const formatValue = (value, fieldFormat = undefined) => {
  /** This should be fixed on the backend */
  const withCommas = !fieldFormat || fieldFormat !== '000000000000000.00';
  const stringVal = value.toString();
  const arrVal = stringVal.split('');
  const [first, ...rest] = arrVal;
  if (first === '0' && arrVal.length > 3) {
    return formatValue(rest.join(''));
  }
  if (arrVal.length <= 2) {
    return stringVal;
  }
  return arrVal.reverse().reduce((format, val, i) => {
    if (i === 1) {
      return `.${val}${format}`;
    }
    if (i > 3 && (i + 1) % 3 === 0 && withCommas) {
      return `${val},${format}`;
    }
    return `${val}${format}`;
  }, '');
};

export default formatValue;
